export default "__VITE_ASSET__DrcJ$XCr__"